"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ValidationDisplayType;
(function (ValidationDisplayType) {
    ValidationDisplayType[ValidationDisplayType["FIELDS"] = 0] = "FIELDS";
    ValidationDisplayType[ValidationDisplayType["FUNCTIONAL"] = 1] = "FUNCTIONAL";
})(ValidationDisplayType = exports.ValidationDisplayType || (exports.ValidationDisplayType = {}));
var ValidationDisplayTypeHelper = /** @class */ (function () {
    function ValidationDisplayTypeHelper() {
        this.priorities = new Map();
        this.priorities.set("FIELDS", ValidationDisplayType.FIELDS);
        this.priorities.set("FUNCTIONAL", ValidationDisplayType.FUNCTIONAL);
    }
    ValidationDisplayTypeHelper.prototype.getDisplayType = function (priority) {
        return this.priorities.get(priority);
    };
    return ValidationDisplayTypeHelper;
}());
exports.ValidationDisplayTypeHelper = ValidationDisplayTypeHelper;
//# sourceMappingURL=validation-display-type.js.map